import React from 'react';
import { Button } from '../ui/button';
import { X, User, CheckCircle, Smartphone, Stethoscope } from 'lucide-react';

export const SmsRecipientModal = ({ sendSmsFromModal, sendingSmsFromModal, setShowSmsModal, setSmsModalData, setSmsRecipient, showSmsModal, smsModalData, smsRecipient }) => (
  <>
    {showSmsModal && smsModalData && (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold flex items-center gap-2">
              <Smartphone className="h-5 w-5 text-green-600" />
              Text {smsModalData.documentName}
            </h3>
            <button 
              onClick={() => { setShowSmsModal(false); setSmsModalData(null); }}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <p className="text-sm text-gray-600 mb-4">Select who should receive this text:</p>

          <div className="space-y-3 mb-6">
            {/* Patient Option */}
            <div 
              onClick={() => setSmsRecipient('patient')}
              className={`p-3 border rounded-lg cursor-pointer transition ${
                smsRecipient === 'patient' ? 'border-green-600 bg-green-50' : 'border-gray-200 hover:border-green-300'
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <User className="h-4 w-4 text-gray-600" />
                  <span className="font-medium">Patient Only</span>
                </div>
                {smsRecipient === 'patient' && <CheckCircle className="h-5 w-5 text-green-600" />}
              </div>
              <p className="text-xs text-gray-500 mt-1">
                {smsModalData.patientName} {smsModalData.patientPhone ? `(${smsModalData.patientPhone})` : '(No phone)'}
              </p>
            </div>

            {/* Dentist/Specialist Option - Show for referrals */}
            {(smsModalData.specialistPhone || smsModalData.documentType === 'referral') && (
              <>
                <div 
                  onClick={() => smsModalData.specialistPhone ? setSmsRecipient('specialist') : null}
                  className={`p-3 border rounded-lg transition ${
                    smsModalData.specialistPhone 
                      ? `cursor-pointer ${smsRecipient === 'specialist' ? 'border-green-600 bg-green-50' : 'border-gray-200 hover:border-green-300'}`
                      : 'cursor-not-allowed bg-gray-50 border-gray-200 opacity-60'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <Stethoscope className="h-4 w-4 text-gray-600" />
                      <span className="font-medium">
                        {smsModalData.documentType === 'referral' ? 'Referred Dentist Only' : 'Specialist Only'}
                      </span>
                    </div>
                    {smsRecipient === 'specialist' && <CheckCircle className="h-5 w-5 text-green-600" />}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    {smsModalData.specialistName || 'Dentist'} {smsModalData.specialistPhone ? `(${smsModalData.specialistPhone})` : '(No phone on file)'}
                  </p>
                </div>

                <div 
                  onClick={() => (smsModalData.specialistPhone && smsModalData.patientPhone) ? setSmsRecipient('both') : null}
                  className={`p-3 border rounded-lg transition ${
                    (smsModalData.specialistPhone && smsModalData.patientPhone)
                      ? `cursor-pointer ${smsRecipient === 'both' ? 'border-green-600 bg-green-50' : 'border-gray-200 hover:border-green-300'}`
                      : 'cursor-not-allowed bg-gray-50 border-gray-200 opacity-60'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <Smartphone className="h-4 w-4 text-gray-600" />
                      <span className="font-medium">
                        {smsModalData.documentType === 'referral' ? 'Both Patient & Dentist' : 'Both Patient & Specialist'}
                      </span>
                    </div>
                    {smsRecipient === 'both' && <CheckCircle className="h-5 w-5 text-green-600" />}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    {(smsModalData.specialistPhone && smsModalData.patientPhone) 
                      ? 'Send to both recipients' 
                      : 'Both phone numbers required'}
                  </p>
                </div>
              </>
            )}
          </div>

          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => { setShowSmsModal(false); setSmsModalData(null); }}>
              Cancel
            </Button>
            <Button 
              onClick={sendSmsFromModal} 
              disabled={sendingSmsFromModal}
              className="bg-green-600 hover:bg-green-700"
            >
              <Smartphone className="h-4 w-4 mr-2" />
              {sendingSmsFromModal ? 'Sending...' : 'Send Text'}
            </Button>
          </div>
        </div>
      </div>
    )}
  </>
);
